<app-camera-view class="dark:block hidden"></app-camera-view>
<app-hero class="dark:hidden"></app-hero>
<app-count-up></app-count-up>

<app-carousel></app-carousel>
<app-carousel-series></app-carousel-series>
<app-mockup-responsive></app-mockup-responsive>
<app-start-register></app-start-register>
